import { render, staticRenderFns } from "./VoucherSetup.vue?vue&type=template&id=4d48725f&scoped=true"
import script from "./VoucherSetup.vue?vue&type=script&lang=js"
export * from "./VoucherSetup.vue?vue&type=script&lang=js"
import style0 from "./VoucherSetup.vue?vue&type=style&index=0&id=4d48725f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48725f",
  null
  
)

export default component.exports